<template>
    <div class="previewBG">
        <div :class="`canvas-box position-relative`">

            <div :id="`${canvas.id}`" :class="` WrapperDiv position-relative`"
                v-bind:style="{ backgroundColor: canvas.bgColor, width: canvas?.size?.width * zoomRatio + 'px', height: canvas?.size?.height * zoomRatio + 'px' }">
                <div class="containerWrapperD">
                    <div :list-index="key" :data-id-t="ObjectItem.id" :data-type="ObjectItem.type"
                        v-for="(ObjectItem, key) of canvas.objects" v-bind:key="ObjectItem.id"
                        :class="`position-absolute ${ObjectItem.lock === true && 'locked'} targetE objTarget_${key} ${ObjectItem.type === 'img' && 'inset-0 overflow-hidden'}`"
                        v-bind:style="{ top: ObjectItem.top * zoomRatio + 'px', opacity: ObjectItem.opacity, left: ObjectItem.left * zoomRatio + 'px', width: ObjectItem.isAuto === true ? 'auto' : ObjectItem.width * zoomRatio + 'px', textAlign: ObjectItem.align, transform: addRotate(ObjectItem), height: ObjectItem?.cType === 'full' || ObjectItem.type === 'qrCodeApp' || ObjectItem.type === 'img' || ObjectItem.type === 'Rectangle' || ObjectItem.type === 'Ellipse' || ObjectItem.type === 'Triangle' || ObjectItem.type === 'Line' ? (ObjectItem.height * zoomRatio) + 'px' : 'auto' }">
                        <!-- <transition appear
                            :enter-active-class="ObjectItem.animationLoop === false ? ObjectItem.animationClass : ''"> -->

                        <div :id="ObjectItem.id"
                            :key="ObjectItem.id + 'TExt' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                            :class="` ${ObjectItem.editable === false ? 'noPointer' : ''}`"
                            v-if="ObjectItem.type === 'text'">
                            <div :key="ObjectItem.id + 'TExt222' + ObjectItem.fontfamily"
                                :contenteditable="ObjectItem.editable" class="wordbsreak select-text" v-bind:style="{
                                    color: ObjectItem.color,
                                    fontSize: ObjectItem.fs * zoomRatio + 'px',
                                    fontWeight: ObjectItem.fw,
                                    fontFamily: ObjectItem.fontfamily,
                                    textDecoration: ObjectItem.underline === true ? 'underline' : 'none',
                                    fontStyle: ObjectItem.italic === true ? 'italic' : 'normal',
                                    lineHeight: ObjectItem.lineHeight,
                                    textTransform: ObjectItem.textTransform,
                                    textShadow: addEffect(ObjectItem),
                                    ...createHollow(ObjectItem),
                                    ...createSplice(ObjectItem),
                                    ...createEcho(ObjectItem),
                                    ...createGlitch(ObjectItem),
                                    ...createNeon(ObjectItem),
                                }">
                                <div>
                                    <span>{{ ObjectItem.text[0] }}</span>
                                </div>
                            </div>


                        </div>
                        <!-- <div class="noPointer" v-if="ObjectItem.type === 'img'" v-bind:style="{opacity:ObjectItem.opacity,backgroundImage: `url(${ObjectItem.url})`,backgroundSize:'cover' ,backgroundRepeat:'no-repeat',backgroundPosition:'center center', width: ObjectItem.width * zoomRatio +'px', height: ObjectItem.height * zoomRatio + 'px' ,top:ObjectItem.top * zoomRatio + 'px',left:ObjectItem.left * zoomRatio + 'px' }">
                            </div>  -->
                        <div :id="ObjectItem.id"
                            :key="ObjectItem.id + 'img' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                            :class="` ${ObjectItem.adjustment === 'burn_effect' ? 'kenburnClass' : ''} noPointer position-absolute inset-0 `"
                            v-if="ObjectItem.type === 'img' && ObjectItem.orientation === 0"
                            v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), opacity: ObjectItem.opacity, backgroundImage: `url(${ObjectItem.url})`, backgroundSize: ObjectItem.adjustment === 'cover' || ObjectItem.adjustment === 'burn_effect' ? 'cover' : ObjectItem.adjustment === 'contain' ? 'contain' : ObjectItem.adjustment === 'stretch' ? '100% 100%' : '', backgroundRepeat: ObjectItem.adjustment === 'tile' ? 'repeat' : 'no-repeat', backgroundPosition: 'center center', borderRadius: ObjectItem.borderRadius + 'px', filter: `brightness(${ObjectItem.brightness}%) contrast(${ObjectItem.contrast}%) saturate(${ObjectItem.saturation}%)` }">
                        </div>
                        <imageOrientation :id="ObjectItem.id"
                            v-if="ObjectItem.type === 'img' && ObjectItem.orientation !== 0" :url="ObjectItem.url"
                            :orientation="ObjectItem.orientation" />
                        <div :id="ObjectItem.id"
                            :key="ObjectItem.id + 'video' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                            :class="` noPointer overflow-hidden`" v-if="ObjectItem.type === 'video'"
                            v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), borderRadius: ObjectItem.borderRadius + 'px', opacity: ObjectItem.opacity, width: ObjectItem.width * zoomRatio + 'px', height: ObjectItem.height * zoomRatio + 'px', top: ObjectItem.top * zoomRatio + 'px', left: ObjectItem.left * zoomRatio + 'px' }">
                            <video crossorigin="anonymous" muted loop="" autoplay preload="auto" :src="ObjectItem.url"
                                class="adujustVideo"></video>

                        </div>
                        <div :id="ObjectItem.id"
                            :key="ObjectItem.id + 'Ellipse' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                            :class="` noPointer overflow-hidden`" v-if="ObjectItem.type === 'Ellipse'"
                            v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), border: `${ObjectItem.borderWidth}px solid ${ObjectItem.borderColor}`, borderRadius: `${ObjectItem.borderRadius}%`, backgroundColor: ObjectItem.bgColor, opacity: ObjectItem.opacity, width: '100%', height: '100%', top: ObjectItem.top * zoomRatio + 'px', left: ObjectItem.left * zoomRatio + 'px' }">
                        </div>
                        <div :id="ObjectItem.id"
                            :key="ObjectItem.id + 'Rectangle' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                            :class="` noPointer overflow-hidden`" v-if="ObjectItem.type === 'Rectangle'"
                            v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), border: `${ObjectItem.borderWidth}px solid ${ObjectItem.borderColor}`, borderRadius: `${ObjectItem.borderRadius}%`, backgroundColor: ObjectItem.bgColor, opacity: ObjectItem.opacity, width: '100%', height: '100%', top: ObjectItem.top * zoomRatio + 'px', left: ObjectItem.left * zoomRatio + 'px' }">
                        </div>
                        <div :id="ObjectItem.id"
                            :key="ObjectItem.id + 'Line' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                            :class="` noPointer overflow-hidden pt-2`" v-if="ObjectItem.type === 'Line'"
                            v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), borderLeft: `${ObjectItem.borderWidth}px solid ${ObjectItem.borderColor}`, borderRadius: `${ObjectItem.borderRadius}%`, backgroundColor: 'transparent', opacity: ObjectItem.opacity, width: 2 + 'px', height: '100%', top: ObjectItem.top * zoomRatio + 'px', left: ObjectItem.left * zoomRatio + 'px' }">
                        </div>

                        <div :id="ObjectItem.id"
                            :key="ObjectItem.id + 'Triangle' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                            :class="` noPointer overflow-hidden`" v-if="ObjectItem.type === 'Triangle'"
                            v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), clipPath: ObjectItem.clip, backgroundColor: ObjectItem.bgColor, opacity: ObjectItem.opacity, width: '100%', height: '100%', top: ObjectItem.top * zoomRatio + 'px', left: ObjectItem.left * zoomRatio + 'px' }">
                        </div>
                        <div :id="ObjectItem.id"
                            :key="ObjectItem.id + 'youtubeApp' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                            :class="` noPointer overflow-hidden`" v-if="ObjectItem.type === 'youtubeApp'"
                            v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), clipPath: ObjectItem.clip, backgroundColor: ObjectItem.bgColor, opacity: ObjectItem.opacity, width: ObjectItem.width * zoomRatio + 'px', height: ObjectItem.height * zoomRatio + 'px', top: ObjectItem.top * zoomRatio + 'px', left: ObjectItem.left * zoomRatio + 'px' }">
                            <youtubeApp :width="ObjectItem.width * zoomRatio" :height="ObjectItem.height * zoomRatio"
                                :src="ObjectItem.url" />
                        </div>
                        <div :id="ObjectItem.id"
                            :key="ObjectItem.id + 'vimeoApp' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                            :class="` noPointer overflow-hidden`" v-if="ObjectItem.type === 'vimeoApp'"
                            v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), clipPath: ObjectItem.clip, backgroundColor: ObjectItem.bgColor, opacity: ObjectItem.opacity, width: ObjectItem.width * zoomRatio + 'px', height: ObjectItem.height * zoomRatio + 'px', top: ObjectItem.top * zoomRatio + 'px', left: ObjectItem.left * zoomRatio + 'px' }">
                            <vimeoApp :width="ObjectItem.width * zoomRatio" :height="ObjectItem.height * zoomRatio"
                                :src="ObjectItem.url" />
                        </div>
                        <div :id="ObjectItem.id"
                            :key="ObjectItem.id + 'newsApp' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                            :class="` noPointer overflow-hidden`" v-if="ObjectItem.type === 'newsApp'"
                            v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), clipPath: ObjectItem.clip, backgroundColor: ObjectItem.bgColor, opacity: ObjectItem.opacity, width: ObjectItem.width * zoomRatio + 'px', height: ObjectItem.height * zoomRatio + 'px', top: ObjectItem.top * zoomRatio + 'px', left: ObjectItem.left * zoomRatio + 'px' }">
                            <newsApp :id="ObjectItem.id" :width="ObjectItem.width * zoomRatio"
                                :height="ObjectItem.height * zoomRatio" :src="ObjectItem.url" />
                        </div>
                        <div :id="ObjectItem.id"
                            :key="ObjectItem.id + 'clockApp' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                            :class="` noPointer overflow-hidden`" v-if="ObjectItem.type === 'clockApp'"
                            v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), clipPath: ObjectItem.clip, opacity: ObjectItem.opacity, }">
                            <clockApp :fs="ObjectItem.fs * zoomRatio" :format="ObjectItem.format"
                                :color="ObjectItem.color" :showSeconds="ObjectItem.showSeconds"
                                :timeZone="ObjectItem.timezone" />
                        </div>
                        <div :id="ObjectItem.id"
                            :key="ObjectItem.id + 'calendarApp' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                            :class="` noPointer overflow-hidden`" v-if="ObjectItem.type === 'calendarApp'"
                            v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), clipPath: ObjectItem.clip, opacity: ObjectItem.opacity, }">
                            <calendarApp :zoomRatio="zoomRatio" :lang="ObjectItem.lang"
                                :beginweek="ObjectItem.beginweek" :Hcolor="ObjectItem.Hcolor"
                                :Dcolor="ObjectItem.Dcolor" :Tcolor="ObjectItem.Tcolor" :bgColorR="ObjectItem.bgColorR"
                                :bgColorL="ObjectItem.bgColorL" :cType="ObjectItem.cType"
                                :calcWidth="ObjectItem.width * zoomRatio" :width="ObjectItem.width * zoomRatio + 'px'"
                                :height="ObjectItem.cType !== 'full' ? 'auto' : ObjectItem.height * zoomRatio + 'px'"
                                :fs="ObjectItem.fs * zoomRatio" :format="ObjectItem.format" :color="ObjectItem.color"
                                :showSeconds="ObjectItem.showSeconds" :timeZone="ObjectItem.timezone" />
                        </div>
                        <div :id="ObjectItem.id"
                            :key="ObjectItem.id + 'webpageApp' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                            :class="` w-100  noPointer overflow-hidden`" v-if="ObjectItem.type === 'webpageApp'"
                            v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), clipPath: ObjectItem.clip, backgroundColor: ObjectItem.bgColor, opacity: ObjectItem.opacity, width: ObjectItem.width * zoomRatio + 'px', height: ObjectItem.height * zoomRatio + 'px', top: ObjectItem.top * zoomRatio + 'px', left: ObjectItem.left * zoomRatio + 'px' }">
                            <WebpageApp :width="ObjectItem.width * zoomRatio" :height="ObjectItem.height * zoomRatio"
                                :src="ObjectItem.url" :isScroll="ObjectItem.isScroll"
                                :scrolltoPhrase="ObjectItem.scrolltoPhrase" :zoomRatio="zoomRatio" />
                        </div>
                        <div :id="ObjectItem.id"
                            :key="ObjectItem.id + 'qrCodeApp' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                            :class="` noPointer w-100 h-100 overflow-hidden`" v-if="ObjectItem.type === 'qrCodeApp'"
                            v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), clipPath: ObjectItem.clip, opacity: ObjectItem.opacity, width: ObjectItem.width * zoomRatio + 'px', height: ObjectItem.height * zoomRatio + 'px', top: ObjectItem.top * zoomRatio + 'px', left: ObjectItem.left * zoomRatio + 'px' }">
                            <qrCodeApp :width="ObjectItem.width * zoomRatio" :height="ObjectItem.height * zoomRatio"
                                :src="ObjectItem.url" :bg="ObjectItem.bgColor" :color="ObjectItem.lineColor"
                                :noBG="ObjectItem.transparentBG" />
                        </div>
                        <div :id="ObjectItem.id"
                            :key="ObjectItem.id + 'weatherApp' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop + key"
                            :class="` noPointer overflow-hidden `" v-if="ObjectItem.type === 'weatherApp'"
                            v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), clipPath: ObjectItem.clip, opacity: ObjectItem.opacity }">
                            <weatherApp :zoom="zoomRatio" :width="ObjectItem.width * zoomRatio"
                                :height="ObjectItem.height * zoomRatio" :city="ObjectItem.city" :unit="ObjectItem.unit"
                                :showForcast="ObjectItem.showForcast" :color="ObjectItem.color"
                                :bgColor="ObjectItem.bgColor" :layout="ObjectItem.layout"
                                :transparentbg="ObjectItem.transparentbg" :fontfamily="ObjectItem.fontfamily"
                                :lang="ObjectItem.lang" :fontSize="ObjectItem.fs * zoomRatio" />
                        </div>
                        <!-- </transition> -->
                        <!-- <div class="OverlayHov"></div> -->
                    </div>

                </div>
            </div>

        </div>
    </div>
</template>
<script>
import youtubeApp from "../components/apps/youtube.vue"
import vimeoApp from "../components/apps/vimeo.vue"
import newsApp from "../components/apps/News.vue"
import imageOrientation from "../components/ImageOrientation.vue"
import clockApp from "../components/apps/Clock.vue"
import calendarApp from "../components/apps/Calendar.vue"
import WebpageApp from "../components/apps/WebPage.vue"
import qrCodeApp from "../components/apps/QRcode.vue"
import weatherApp from "../components/apps/weather.vue"

export default {
    name: "PreviewCanvas",
    data() {
        return {
            canvas: {},
            zoomRatio: 0,
            animation: null,
            animationRequest: null,
            slideval: 0,
            animationRunning: false
        }
    },
    props: {
        isvisiblemodal: Boolean,
        isPlayAnimation: Boolean,
        sliderValue: {
            type: Number,
            required: true
        },
        maxSliderValue: Number,
        activeSlide: Number

    },

    components: {
        youtubeApp,
        vimeoApp,
        newsApp,
        imageOrientation,
        clockApp,
        calendarApp,
        WebpageApp,
        qrCodeApp,
        weatherApp
    },
    mounted() {
        console.log("this.getAllCanvas")
        console.log(this.getAllCanvas);


    },
    watch: {
        isvisiblemodal(value) {
            if (value === true) {
                this.$nextTick(() => {
                    debugger // eslint-disable-line no-debugger
                    let canvasss = this.getAllCanvas[0];
                    let ratio = this.getResolutionScaleValue(canvasss.size.width, canvasss.size.height);
                    this.zoomRatio = ratio
                    console.log(ratio)
                    this.canvas = canvasss;
                    let value = 0;
                    canvasss.objects.map(x => value = value + x.animationDelayIn + x.animationDelayOut + x.animationDurationIn + x.animationDurationOut);
                    console.log(value);
                    this.$emit("updateSliderMaxValue", canvasss.slideDuration)
                    console.log(canvasss.slideDuration);

                    console.log(canvasss);
                });
            }
        },
        // canvas(value){
        //     debugger // eslint-disable-line no-debugger
        //     if(Object.keys(value).length > 0){
        //         this.$nextTick(() => { 
        //             this.animateElements();

        //         });
        //     }
        // },
        isPlayAnimation(value) {
            this.animateElements(value)
        },
        activeSlide(index) {
            let canvasss = this.getAllCanvas[index];
            let ratio = this.getResolutionScaleValue(canvasss.size.width, canvasss.size.height);
            this.zoomRatio = ratio
            console.log(ratio)
            this.canvas = canvasss;
            let value = 0;
            canvasss.objects.map(x => value = value + x.animationDelayIn + x.animationDelayOut + x.animationDurationIn + x.animationDurationOut);
            console.log(value);
            this.$emit("updateSliderMaxValue", canvasss.slideDuration);
            console.log('canvasss.duration', canvasss.slideDuration);
            console.log('canvasss');
            console.log(canvasss);
        }
    },
    computed: {
        getAllCanvas() {
            return this.$store.getters.getCanvasInstances;
        }
    },
    methods: {
        createShadow(obj) {
            let radius = obj.offset / 10;
            let Hshadow = radius * Math.sin(Math.PI * 2 * obj.direction / 360);
            let Yshadow = radius * Math.cos(Math.PI * 2 * obj.direction / 360);
            let blur = obj.blur / 10;
            let color = obj?.color.replace(")", "," + obj.transparency / 100 + ")").replace("rgb", "rgba");
            let shadow = `${Hshadow}px ${Yshadow}px ${blur}px ${color}`;
            console.log(shadow)
            return shadow
        },
        createLift(obj) {


            let intensity = obj.intensity;

            let lift = `7.5px 0px ${obj.intensity * .5}px rgba(0,0,0, ${(intensity * .75) / 100})`;
            console.log(lift)
            return lift
        },
        createHollow(obj) {
            if (obj.effectType?.type === "hollow") {
                let thickness = obj?.effectType?.thickness;
                let holow = "";
                if (obj) {
                    holow = {
                        caretColor: obj?.color,
                        "-webkit-text-stroke": `${thickness / 18}px ${obj?.color}`,
                        "-webkit-text-fill-color": `transparent`,
                    }
                    return (holow)
                }

            } else {
                return ""

            }

        },
        createSplice(obj) {
            if (obj.effectType?.type === "splice") {
                if (obj) {
                    let thickness = obj?.effectType?.thickness;
                    let radius = obj.effectType?.offset / 18;
                    let Hshadow = radius * Math.sin(Math.PI * 2 * obj.effectType?.direction / 360);
                    let Yshadow = radius * Math.cos(Math.PI * 2 * obj.effectType?.direction / 360);
                    let color = obj.color;
                    let shadow = `${Hshadow}px ${Yshadow}px ${0}px ${color}`;
                    let holow = {
                        textShadow: shadow,
                        caretColor: obj?.effectType?.color,
                        "-webkit-text-stroke": `${thickness / 18}px ${obj?.effectType?.color}`,
                        "-webkit-text-fill-color": `transparent`,
                    }
                    return holow
                }
            } else {
                return ""

            }

        },
        createEcho(obj) {
            if (obj.effectType?.type === "echo") {
                if (obj) {
                    let radius = obj.effectType?.offset / 10;
                    let Hshadow = radius * Math.sin(Math.PI * 2 * obj.effectType?.direction / 360);
                    let Yshadow = radius * Math.cos(Math.PI * 2 * obj.effectType?.direction / 360);
                    let color = obj.effectType?.color.replace(')', ', 0.50)').replace('rgb', 'rgba');
                    let color2 = obj.effectType?.color.replace(')', ', 0.30)').replace('rgb', 'rgba');
                    let shadow = `${Hshadow}px ${Yshadow}px ${0}px ${color} , ${Hshadow * 2}px ${Yshadow * 2}px ${0}px ${color2}`;
                    let echo = {
                        textShadow: shadow,
                    }
                    return echo
                }
            } else {
                return ""

            }

        },
        createGlitch(obj) {
            if (obj.effectType?.type === "glitch") {
                if (obj) {
                    let radius = obj.effectType?.offset / 15;
                    let Hshadow = radius * Math.sin(Math.PI * 2 * obj.effectType?.direction / 360);
                    let Yshadow = radius * Math.cos(Math.PI * 2 * obj.effectType?.direction / 360);
                    let color = obj.effectType?.color;
                    let shadow = `${Hshadow}px ${Yshadow}px ${0}px rgb(0, 255, 255) , ${-(Hshadow)}px ${-(Yshadow)}px ${0}px ${color}`;
                    let echo = {
                        textShadow: shadow,
                    }
                    return echo
                }
            } else {
                return ""

            }

        },
        createAnimationVar(animationClass, duration, delay, motionDuration) {
            let obj = {
                '--animate-motion-duration': motionDuration * 1000 + 'ms',
                '--animate-duration': duration * 1000 + 'ms',
                '--animate-delay': delay * 1000 + 'ms',
            }
            return animationClass !== "" ? obj : {}
        },
        hexToRgb(hexColor) {
            // Remove "#" from the beginning if present
            const colorString = hexColor.startsWith('#') ? hexColor.substring(1) : hexColor;

            // Parse the hexadecimal color components
            const r = parseInt(colorString.substring(0, 2), 16);
            const g = parseInt(colorString.substring(2, 4), 16);
            const b = parseInt(colorString.substring(4, 6), 16);

            // Return the RGB values as an object
            return { r: r, g: g, b: b };
        },
        adjustColorIntensity(color, intensity) {
            // Validate intensity value (should be between 0 and 100)
            if (intensity < 0 || intensity > 100) {
                throw new Error('Intensity value should be between 0 and 100');
            }

            // Convert color to HSL
            const rgb = color.match(/\w{2}/g).map(hex => parseInt(hex, 16));
            const r = rgb[0] / 255;
            const g = rgb[1] / 255;
            const b = rgb[2] / 255;

            const max = Math.max(r, g, b);
            const min = Math.min(r, g, b);
            let h, s, l = (max + min) / 2;

            if (max === min) {
                h = s = 0; // achromatic
            } else {
                const d = max - min;
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

                switch (max) {
                    case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                    case g: h = (b - r) / d + 2; break;
                    case b: h = (r - g) / d + 4; break;
                }

                h /= 6;
            }

            // Adjust lightness based on intensity
            l = l + (1 - l) * intensity / 100;
            l = Math.min(1, Math.max(0, l)); // Ensure lightness stays between 0 and 1

            // Convert back to RGB
            let rOut, gOut, bOut;

            if (s === 0) {
                rOut = gOut = bOut = l; // achromatic
            } else {
                const hue2rgb = (p, q, t) => {
                    if (t < 0) t += 1;
                    if (t > 1) t -= 1;
                    if (t < 1 / 6) return p + (q - p) * 6 * t;
                    if (t < 1 / 2) return q;
                    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                    return p;
                };

                const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                const p = 2 * l - q;

                rOut = hue2rgb(p, q, h + 1 / 3);
                gOut = hue2rgb(p, q, h);
                bOut = hue2rgb(p, q, h - 1 / 3);
            }

            // Convert back to hex color code
            const toHex = (c) => Math.round(c * 255).toString(16).padStart(2, '0');
            const newColor = `#${toHex(rOut)}${toHex(gOut)}${toHex(bOut)}`;
            console.log("newColor")
            console.log(newColor)

            // Calculate the drop-shadow color based on intensity
            const dropShadowR = r + (1 - r) * 20 / 100;
            const dropShadowG = g + (1 - g) * 20 / 100;
            const dropShadowB = b + (1 - b) * 20 / 100;
            const dropShadowColor = `#${toHex(dropShadowR)}${toHex(dropShadowG)}${toHex(dropShadowB)}`;
            console.log("dropShadowColor")
            console.log(dropShadowColor)

            return { newcolor: newColor, dropdshadow: dropShadowColor };
        },
        createNeon(obj) {
            if (obj.effectType?.type === "neon") {
                if (obj) {
                    let createdColor = this.adjustColorIntensity(obj.color, obj.effectType?.intensity).newcolor;
                    let dropshadow = this.adjustColorIntensity(obj.color, obj.effectType?.intensity).dropdshadow;
                    let intensity = obj.effectType?.intensity;
                    let shadow = `drop-shadow(rgba(${this.hexToRgb(dropshadow).r}, ${this.hexToRgb(dropshadow).g}, ${this.hexToRgb(dropshadow).b}, 0.95) 0px 0px ${intensity > 50 ? intensity / 45 : 65 / 45}px) drop-shadow(rgba(${this.hexToRgb(obj.color).r}, ${this.hexToRgb(obj.color).g}, ${this.hexToRgb(obj.color).b}, 0.75) 0px 0px ${intensity > 50 ? intensity / 13 : 65 / 13}px) drop-shadow(rgba(${this.hexToRgb(obj.color).r}, ${this.hexToRgb(obj.color).g}, ${this.hexToRgb(obj.color).b}, 0.44) 0px 0px ${intensity / 8.2}px)`
                    let filter = {
                        color: createdColor,
                        filter: shadow,
                    }
                    return filter
                }
            } else {
                return ""

            }

        },
        addEffect(obj) {

            switch (obj.effectType?.type) {
                case 'shadow':
                    return this.createShadow(obj.effectType)
                case 'lift':
                    return this.createLift(obj.effectType)

                default:
                    ''
                    break;
            }

        },
        addRotate(obj) {
            return `rotate(${obj.rotate}deg)`
        },
        getResolutionScaleValue(width, height) {

            // if (height > width) {
            //     let ratio = width / height;
            //     let ParentHeight = document.querySelector(".previewBG").parentElement.offsetHeight;
            //     let newWidth = ratio * ParentHeight;
            //     let newwidths = newWidth / width;
            //     return Number(newwidths.toFixed(2)) - 0.02
            // } else {
            //     let ratio = height / width;
            //     let ParentWidth = document.querySelector(".previewBG").parentElement.offsetWidth;
            //     let newWidth = ratio * ParentWidth;
            //     let newwidths = newWidth / height;
            //     return Number(newwidths.toFixed(2)) - 0.04
            // }

            const parentElement = document.querySelector(".previewBG")?.parentElement;
            const ParentWidth = parentElement?.offsetWidth || 0;
            const ParentHeight = parentElement?.offsetHeight || 0;

            // Calculate the maximum scale value ensuring the child stays inside the canvas
            const scaleX = ParentWidth / width;
            const scaleY = (ParentHeight - 50) / height;

            // Use the smaller scale to ensure the child fits within the canvas
            const scale = Math.min(scaleX, scaleY);

            return scale;


        },
        animateElements(value) {
            this.canvas?.objects.forEach(obj => {
                // const animatedElement = document.getElementById(obj?.id).parentElement;
                console.log(value)
                if (value === true) {
                    this.startAnimation(obj?.id, obj)
                } else {
                    this.stopAnimation(obj?.id, obj)
                }
                // animatedElement.classList.add('animate__animated', obj.animationClassIn);
            });
        },
        startAnimation(id, obj) {
            const el = document.getElementById(id);
            if (!el) return;

            const hasIN = obj.AnimationSequence.includes("IN");
            const hasLOOP = obj.AnimationSequence.includes("LOOP");
            const hasOUT = obj.AnimationSequence.includes("OUT");

            if (hasIN && hasLOOP && hasOUT) {
                obj.AnimationSequence = ["IN", "LOOP", "OUT"];
            } else if (!hasIN && hasLOOP && hasOUT) {
                obj.AnimationSequence = ["LOOP", "OUT"];
            } else if (hasIN && !hasLOOP && hasOUT) {
                obj.AnimationSequence = ["IN", "OUT"];
            } else if (hasIN && hasLOOP && !hasOUT) {
                obj.AnimationSequence = ["IN", "LOOP"];
            }

            let currentTimeOffset = 0;
            let animationTimeline = [];
            let lastAnimationEndTime = 0;


            if (obj.AnimationSequence.includes("IN") && this.getAnimationClass(id, "In")) {
                el.style.opacity = "0";
            }

            obj.AnimationSequence.forEach((animationType) => {
                let startTime = currentTimeOffset;
                let duration = 0;

                if (animationType === "IN" && this.getAnimationClass(id, "In")) {
                    const animationStartIn = this.getAnimationDelay(id, "In");
                    duration = this.getAnimationDuration(id, "In");

                    startTime = animationStartIn;
                    currentTimeOffset = startTime + duration;
                    lastAnimationEndTime = currentTimeOffset;
                } else if (animationType === "OUT" && this.getAnimationClass(id, "Out")) {
                    const animationStartOut = this.getAnimationDelay(id, "Out");
                    duration = this.getAnimationDuration(id, "Out");

                    startTime = animationStartOut;
                    currentTimeOffset = startTime + duration;
                    lastAnimationEndTime = currentTimeOffset;
                } else if (animationType === "LOOP" && obj.animationClassLoop) {
                    duration = obj.animationLoopDuration;
                    startTime = lastAnimationEndTime ? lastAnimationEndTime : 0;
                    currentTimeOffset = startTime + duration;
                }

                animationTimeline.push({ type: animationType, startTime, duration });
            });

            obj.AnimationSequence.forEach((animationType, index) => {
                let animationData = animationTimeline[index];
                let startTimeMs = animationData.startTime * 1000;
                let endTimeMs = (animationData.startTime + animationData.duration) * 1000;

                setTimeout(() => {
                    if (animationType === "LOOP" && obj.animationClassLoop) {
                        this.removeClassNames(el, obj.animationClassLoop);
                        if (obj.AnimationSequence.includes("IN")) {
                            this.removeClassNames(el, this.getAnimationClass(id, "In"));
                        }
                        if (obj.AnimationSequence.includes("OUT")) {
                            this.removeClassNames(el, this.getAnimationClass(id, "Out"));
                        }

                        let animationVars = this.createAnimationVar(obj.animationClassLoop, obj.animationLoopDuration, 0, 2);
                        this.applyAnimationVars(el, animationVars);
                        void el.offsetWidth;
                        this.addClassNames(el, obj.animationClassLoop);
                        el.style.animationIterationCount = "infinite";
                    }

                    if (animationType === "IN" && this.getAnimationClass(id, "In")) {
                        this.removeClassNames(el, this.getAnimationClass(id, "In"));
                        if (obj.AnimationSequence.includes("OUT")) {
                            this.removeClassNames(el, this.getAnimationClass(id, "Out"));
                        }
                        if (obj.AnimationSequence.includes("LOOP")) {
                            this.removeClassNames(el, obj.animationClassLoop);
                        }

                        let animationVars = this.createAnimationVar(this.getAnimationClass(id, "In"), animationData.duration, 0, 1);
                        this.applyAnimationVars(el, animationVars);
                        void el.offsetWidth;
                        this.addClassNames(el, this.getAnimationClass(id, "In"));
                        el.style.animationIterationCount = "1";
                        requestAnimationFrame(() => {
                            el.style.opacity = "1";
                        });
                    }

                    if (animationType === "OUT" && this.getAnimationClass(id, "Out")) {
                        this.removeClassNames(el, this.getAnimationClass(id, "Out"));
                        if (obj.AnimationSequence.includes("IN")) {
                            this.removeClassNames(el, this.getAnimationClass(id, "In"));
                        }
                        if (obj.AnimationSequence.includes("LOOP")) {
                            this.removeClassNames(el, obj.animationClassLoop);
                        }

                        let animationVars = this.createAnimationVar(this.getAnimationClass(id, "Out"), animationData.duration, 0, 1);
                        this.applyAnimationVars(el, animationVars);
                        void el.offsetWidth;
                        this.addClassNames(el, this.getAnimationClass(id, "Out"));
                        el.style.animationIterationCount = "1";
                    }
                }, startTimeMs);

                setTimeout(() => {
                    if (animationType === "IN" && this.getAnimationClass(id, "In")) {
                        this.removeClassNames(el, this.getAnimationClass(id, "In"));
                    }
                    // if (animationType === "OUT" && this.getAnimationClass(id, "Out")) {
                    //     this.removeClassNames(el, this.getAnimationClass(id, "Out"));
                    // }
                }, endTimeMs);
            });

            this.startSliderAnimation();
        },
        applyAnimationVars(el, vars) {
            for (const [key, value] of Object.entries(vars)) {
                el.style.setProperty(key, value);
            }
        },
        stopAnimation(id, obj) {
            this.stopSliderAnimation();
            const el = document.getElementById(id);
            if (el) {
                debugger // eslint-disable-line no-debugger
                let animationVars = this.createAnimationVar(this.getAnimationClass(id, "In"), "", "", "");
                this.applyAnimationVars(el, animationVars);
                if (obj && obj.animationClassLoop) {
                    this.removeClassNames(el, obj.animationClassLoop);
                }
                this.removeClassNames(el, this.getAnimationClass(id, "Out"));
                this.removeClassNames(el, this.getAnimationClass(id, "In"));
                void el.offsetWidth; // Trigger reflow to restart the animation

            }

        },
        getAnimationClass(id, type) {
            const item = this.canvas?.objects.find(i => i.id === id);
            return item ? (type === "In" ? item.animationClassIn : item.animationClassOut) : "";
        },
        getAnimationDelay(id, type) {
            const item = this.canvas?.objects.find(i => i.id === id);
            return item ? (type === "In" ? item.animationDelayIn : item.animationDelayOut) : 0;
        },
        getAnimationDuration(id, type) {
            const item = this.canvas?.objects.find(i => i.id === id);
            return item ? (type === "In" ? item.animationDurationIn : item.animationDurationOut) : 1;
        },
        addClassNames(el, classNames) {
            classNames.split(' ').forEach(className => {
                el.classList.add(className);
            });
        },
        removeClassNames(el, classNames) {
            classNames.split(' ').forEach(className => {
                el.classList.remove(className);
            });
        },
        startSliderAnimation() {
            if (this.animationRunning) return; // Prevent multiple animations
            this.animationRunning = true;
            const step = () => {
                if (!this.animationRunning) return; // Exit if animation should be stopped
                // this.sliderValue += 1;
                const newValue = this.sliderValue + 1;
                console.log(newValue)
                if (newValue <= this.maxSliderValue) {

                    this.slideval += 1
                    console.log(this.slideval)
                    this.$emit('update-slider-value', newValue);
                    setTimeout(() => {
                        this.animationRequest = requestAnimationFrame(step);
                    }, 1000);
                } else {
                    //   this.sliderValue = 0; // Reset slider to loop animation
                    this.$emit('update-slider-value', 0);
                    this.slideval = 0
                    setTimeout(() => {
                        this.animationRequest = requestAnimationFrame(step);
                    }, 1000);

                }
            };
            this.animationRequest = requestAnimationFrame(step);
        },
        stopSliderAnimation() {
            this.animationRunning = false; // Reset animation state
            this.$emit('update-slider-value', 0);
            if (this.animationRequest) {
                cancelAnimationFrame(this.animationRequest);
                this.animationRequest = null;

            }
        },

    }
}
</script>

<style scoped>
.previewBG {
    height: auto;
    width: 100%;
}

.wordbreak {
    word-break: break-all;
}

.canvas-box {
    margin: 1rem auto;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    border: 3px solid transparent;

}

.noPointer {
    pointer-events: none;
    user-select: none;
}

.CanvasWrapper {
    flex: 1 1 0%;
}

.WrapperDiv {
    overflow: hidden;
}

/* .canvas-box:hover {
    border: 3px solid #8e42ff;
} */

.context-menu {
    position: absolute;
    width: 185px;
    z-index: 9;
    background-color: #fff;
    border: 1px solid rgba(64, 87, 109, 0.07);
    box-shadow: 0 2px 8px rgba(53, 71, 90, 0.2);
    border-radius: 4px;
    padding: 0.8rem 0;

}

.ContextMenuItemContainer {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 0 0.8rem;

}

.ContextMenuItemContainer:hover {
    background: rgba(0, 0, 0, 0.06);
}

.smallSize {
    font-size: 12px;
    margin-left: 10px;
}

.divider {
    margin-bottom: .5rem;
    margin-top: .5rem;
    border-color: rgb(221 226 229);
}

.inset-0 {
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
}

.adujustVideo {
    object-fit: contain;
    width: 100%;
    height: 100%;

}

.targetE:not(.locked):hover .OverlayHov {
    opacity: 1;
}

.targetE.locked:hover {
    outline: #6baeff auto;
}

.OverlayHov {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.25);
    pointer-events: none;
    opacity: 0;
}

div[data-type='Line'] .OverlayHov {
    padding: 15px;
    pointer-events: visible;
}

.inset-0 {
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
}

.select-text {
    -webkit-user-select: text;
    user-select: text;
}

.croshair.WrapperDiv {
    cursor: crosshair;
}

.kenburnClass {
    transform-origin: 50% 100% 0px;
    animation: kenburn 60s linear 0s infinite alternate;
}




@keyframes kenburn {
    0% {
        transform: scale(1);
    }

    100% {
        transform: scale(1.5);
    }
}
</style>